<template>
  <div class="p-reporters">
    <span>エリアレポーター募集中!</span><br>
    あなたの目線でミュージアムや展覧会をレポートしてみませんか？<br>
    <div class="p-reporters_link">
      <a href="https://www.museum.or.jp/static/area-reporter-information">
        →　詳しくはこちらまで
      </a>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.p-reporters {
  margin-top: 25px;
  line-height: 1.8;

  span {
    margin-bottom: 5px;
    color: orangered;
    font-weight: bold;
  }

  &_link {
    text-align: right;
  }
}
</style>
